/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Error_InvalidInputs */

const en_reference_error_invalid = /** @type {(inputs: Reference_Error_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not valid`)
};

/**
* | output |
* | --- |
* | "Not valid" |
*
* @param {Reference_Error_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_error_invalid = /** @type {((inputs?: Reference_Error_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Error_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_error_invalid(inputs)
});